import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import ScaleLoader from 'Components/ScaleLoader';

import { clinicalClaimsContent } from 'assets/content/checkout';

import { BasicModal } from './BasicModal';
import Spacer from './Spacer';
import { Typography } from './Typography';

const Black = styled.span`
  color: ${theme.colors.primary[400]};
`;

type ClinicalClaimsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  product?: keyof typeof clinicalClaimsContent;
};

const ClinicalClaimsModal = ({ isOpen, onClose, product }: ClinicalClaimsModalProps) => {
  return (
    <BasicModal dataTestId="clinical-modal-closer" isOpen={isOpen} onClose={onClose}>
      {product && isOpen ? (
        <>
          <Typography color="grey" variant="p3">
            <Black>{clinicalClaimsContent[product]?.header}</Black>
            {' - '}
            {clinicalClaimsContent[product]?.numbers}
          </Typography>
          <Spacer size={8} />

          <Typography color="grey" italic variant="p3">
            {clinicalClaimsContent[product]?.detail}
          </Typography>
        </>
      ) : (
        <ScaleLoader color={theme.colors.neutral['900']} margin="5px" />
      )}
    </BasicModal>
  );
};

export default ClinicalClaimsModal;
